import moment from 'moment'

export default (time) => {
    if (!time) return ''

    const timeM = moment(time)
    if (!timeM.isValid()) return time

    return timeM.format('DD/MM/YYYY, h:mm:ss a')
}
